window.addEventListener('load', async () => {
    const image_switcher = document.querySelector("[data-image-switcher]");
    if (!image_switcher) return;
    const module = await import('./image-switcher')
    module.default();
});
